import { render, staticRenderFns } from "./participant-small-info-card.vue?vue&type=template&id=b997353e&scoped=true&"
import script from "./participant-small-info-card.vue?vue&type=script&lang=ts&"
export * from "./participant-small-info-card.vue?vue&type=script&lang=ts&"
import style0 from "./participant-small-info-card.vue?vue&type=style&index=0&id=b997353e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b997353e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
